import { call, put, takeLatest } from 'redux-saga/effects';
import { post } from '../../../helpers/api_helper';
import * as types from './actionTypes';

function* fetchClaimReportsSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_FETCH_GET_CLAIMREPORTS, action.payload);
    yield put({ type: types.FETCH_CLAIM_REPORTS_SUCCESS, payload: response.data });
  } catch (error) {
    yield put({ type: types.FETCH_CLAIM_REPORTS_FAILURE, payload: error.message });
  }
}

export default function* reimbursementReportsSaga() {
  yield takeLatest(types.FETCH_CLAIM_REPORTS_REQUEST, fetchClaimReportsSaga);
}
